var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#D94854"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10304_29581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2792 6C19.1401 6 19.9044 6.55086 20.1766 7.36754L20.7208 9H24C24.5523 9 25 9.44772 25 10C25 10.5523 24.5523 11 24 11L23.9975 11.0712L23.1301 23.2137C23.018 24.7837 21.7117 26 20.1378 26H11.8622C10.2883 26 8.982 24.7837 8.86986 23.2137L8.00254 11.0712C8.00083 11.0473 7.99998 11.0236 7.99996 11C7.44769 11 7 10.5523 7 10C7 9.44772 7.44772 9 8 9H11.2792L11.8234 7.36754C12.0956 6.55086 12.8599 6 13.7208 6H18.2792ZM21.9975 11H10.0026L10.8648 23.0712C10.9022 23.5946 11.3376 24 11.8622 24H20.1378C20.6624 24 21.0978 23.5946 21.1352 23.0712L21.9975 11ZM14 14C14.5128 14 14.9355 14.386 14.9933 14.8834L15 15V20C15 20.5523 14.5523 21 14 21C13.4872 21 13.0645 20.614 13.0067 20.1166L13 20V15C13 14.4477 13.4477 14 14 14ZM18 14C18.5523 14 19 14.4477 19 15V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20V15C17 14.4477 17.4477 14 18 14ZM18.2792 8H13.7208L13.3874 9H18.6126L18.2792 8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10304_29581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d9ad3170c950e9696b66719b3c12863c.svg";
export { ForwardRef as ReactComponent };